import * as React from 'react';
import ILegalEntity from './ILegalEntity';
import { Translate } from '../../shared/LanguageService';
import { Button, ButtonToolbar } from 'react-bootstrap';
import DeleteButton from '../../components/common/DeleteButton';

interface LegalEntityListRowProps {
    LegalEntity: ILegalEntity;
    key: number;
    edit: (id: number) => void;
    delete: (id: number) => void;
}

const LegalEntityListRow = (props: LegalEntityListRowProps) => {
    return (
        <tr>
            <td>{props.LegalEntity.name}</td>
            <td>{props.LegalEntity.organizationNumber}</td>
            <td>
                <ButtonToolbar className="btn-group-sm pull-right">
                    <DeleteButton
                        onDelete={() => {
                            props.delete(props.LegalEntity.id);
                        }}
                        text={Translate('legalentities/list/row/delete/remove-this-legal-entity')}
                    >
                        <i className="material-icons">delete</i>{' '}
                        {Translate('legalentities/list/row/button-label/delete')}
                    </DeleteButton>
                    <Button
                        onClick={() => {
                            props.edit(props.LegalEntity.id);
                        }}
                        bsStyle="primary"
                    >
                        <i className="material-icons">edit</i>{' '}
                        {Translate('legalentities/list/row/button-label/edit')}
                    </Button>
                </ButtonToolbar>
            </td>
        </tr>
    );
};

export default LegalEntityListRow;
